export type SubjectModel = {
  id: string;
  subjectId: number;
  expertApplyId: string;
  name: string;
  qualificationTypeId: number;
  qualificationType: string;
  qualificationLevelId: number;
  qualificationLevels: SubjectLevelModel[];
  expertiseType: ExpertiseType;
  selectedAssessmentActivities: AssessmentActivities;
  teachingActivity: TeachingActivity;
  hadQual: boolean;
};

export type SubjectAddModel = {
  subjectId: number;
  qualificationTypeId: number;
  qualificationLevels: number[];
  expertiseType: number[];
  selectedAssessmentActivities: number[];
  teachingActivity: number[];
};

export type SubjectLevelModel = {
  id: string;
  subjectId: string;
  levelId: number;
};

export enum ExpertiseType {
  None = 0,
  Assessment = 1,
  Industry = 2,
  Teaching = 4,
};

export enum AssessmentActivities {
  None = 0,
  MarkingAssessments = 1,
  StandardSettingAndAwardingQualifications = 2,
  DesigningAndDevelopingAssessments = 4,
  EvaluatingAssessments = 8,
};

export enum TeachingActivity {
  None = 0,
  TeachingOrLecturing = 1,
  Training = 2,
  EducationalManagement = 4,
  TeacherTraining = 8,
};
